import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetOperationsWithdrawal = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_WITHDRAWAL_OPERATIONS_GGR
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetOperationsWithdrawalAction(data.data));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetOperationsWithdrawal as SetGetOperationsWithdrawal
}